import c1 from "../assets/menu/images/urban-espresso.jpg";
import c2 from "../assets/menu/images/velvet-latte.jpg";
import c3 from "../assets/menu/images/iced-caramel-macchiato.jpg";
import c4 from "../assets/menu/images/mocha-cloud.jpg";
import c5 from "../assets/menu/images/hazelnut-cold-brew.jpg";
import c6 from "../assets/menu/images/classic-americano.jpg";
import t1 from "../assets/menu/images/jasmine-pearl.jpg";
import t2 from "../assets/menu/images/hibiscus-iced.jpg";
import t3 from "../assets/menu/images/kashmiri-kahwa.jpg";
import t4 from "../assets/menu/images/masala-chai.jpg";
import t5 from "../assets/menu/images/matcha-genmaicha.jpg";
import t6 from "../assets/menu/images/turmeric-ginger.jpg";
import p1 from "../assets/menu/images/croissant-delight.jpg";
import p2 from "../assets/menu/images/blueberry-muffin.jpg";
import p3 from "../assets/menu/images/chocolate-danish.jpg";
import p4 from "../assets/menu/images/lemon-tart.jpg";
import p5 from "../assets/menu/images/almond-biscotti.jpg";
import p6 from "../assets/menu/images/red-velvet-cupcake.jpg";
import cb from "../assets/menu/images/coffee-banner.jpg";
import tb from "../assets/menu/images/tea-banner.jpg";
import pb from "../assets/menu/images/pastries-banner.jpg";
import mb from "../assets/menu/images/menu-banner.jpg";

const categories = ["All", "Coffees", "Teas", "Pastries"];

const foodItems = [
  // Coffees
  {
    id: 1,
    name: "Urban Espresso",
    category: "Coffees",
    description: "Rich and bold shot of espresso.",
    price: 120,
    tags: ["hot"],
    image: c1,
  },
  {
    id: 2,
    name: "Velvet Latte",
    category: "Coffees",
    description: "Smooth and creamy hot latte with delicate foam.",
    price: 150,
    tags: ["hot"],
    image: c2,
  },
  {
    id: 3,
    name: "Iced Caramel Macchiato",
    category: "Coffees",
    description: "Chilled espresso with caramel and milk.",
    price: 180,
    tags: ["cold"],
    image: c3,
  },
  {
    id: 4,
    name: "Mocha Cloud",
    category: "Coffees",
    description: "Chocolate infused mocha topped with cream.",
    price: 170,
    tags: ["hot"],
    image: c4,
  },
  {
    id: 5,
    name: "Hazelnut Cold Brew",
    category: "Coffees",
    description: "Smooth cold brew with a nutty hazelnut twist.",
    price: 190,
    tags: ["cold"],
    image: c5,
  },
  {
    id: 6,
    name: "Classic Americano",
    category: "Coffees",
    description: "Simple black coffee with deep flavor.",
    price: 110,
    tags: ["hot"],
    image: c6,
  },

  // Teas
  {
    id: 7,
    name: "Jasmine Pearl Green Tea",
    category: "Teas",
    description: "Elegant green tea with floral jasmine aroma.",
    price: 220,
    tags: ["hot"],
    image: t1,
  },
  {
    id: 8,
    name: "Hibiscus Iced Tea",
    category: "Teas",
    description: "Refreshing hibiscus brew served cold.",
    price: 180,
    tags: ["cold"],
    image: t2,
  },
  {
    id: 9,
    name: "Kashmiri Kahwa",
    category: "Teas",
    description: "Spiced green tea with almonds and saffron.",
    price: 250,
    tags: ["hot"],
    image: t3,
  },
  {
    id: 10,
    name: "Masala Chai Latte",
    category: "Teas",
    description: "Classic Indian spiced tea with milk.",
    price: 200,
    tags: ["hot"],
    image: t4,
  },
  {
    id: 11,
    name: "Matcha Genmaicha Blend",
    category: "Teas",
    description: "Green tea with roasted rice and matcha.",
    price: 270,
    tags: ["hot"],
    image: t5,
  },
  {
    id: 12,
    name: "Turmeric Ginger Detox Tea",
    category: "Teas",
    description: "A zesty blend to boost immunity.",
    price: 190,
    tags: ["hot"],
    image: t6,
  },

  // Pastries
  {
    id: 13,
    name: "Croissant Delight",
    category: "Pastries",
    description: "Flaky butter croissant baked to perfection.",
    price: 120,
    tags: [],
    image: p1,
  },
  {
    id: 14,
    name: "Blueberry Muffin",
    category: "Pastries",
    description: "Moist muffin bursting with blueberries.",
    price: 100,
    tags: [],
    image: p2,
  },
  {
    id: 15,
    name: "Chocolate Danish",
    category: "Pastries",
    description: "Swirled pastry filled with chocolate cream.",
    price: 130,
    tags: [],
    image: p3,
  },
  {
    id: 16,
    name: "Lemon Tart",
    category: "Pastries",
    description: "Tangy lemon filling in a crispy tart shell.",
    price: 110,
    tags: [],
    image: p4,
  },
  {
    id: 17,
    name: "Almond Biscotti",
    category: "Pastries",
    description: "Crunchy twice-baked almond cookie.",
    price: 90,
    tags: [],
    image: p5,
  },
  {
    id: 18,
    name: "Red Velvet Cupcake",
    category: "Pastries",
    description: "Moist red velvet cupcake with cream cheese frosting.",
    price: 140,
    tags: [],
    image: p6,
  },
];

const getBannerImage = (category) => {
  switch (category) {
    case "Coffees":
      return cb;
    case "Teas":
      return tb;
    case "Pastries":
      return pb;
    default:
      return mb;
  }
};

export default { categories, foodItems, getBannerImage };
